import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "success" }
const _hoisted_2 = { class: "campaign-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, { error: _ctx.error }, {
    default: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('booking.tripDetails.discount.title')), 1),
      (_ctx.data)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 0,
            type: "success"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.data.campaign), 1),
                _createVNode(_component_BaseButton, {
                  loading: _ctx.loading,
                  onClick: _ctx.remove,
                  class: "button--white"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Remove code")
                  ])),
                  _: 1,
                  __: [2]
                }, 8, ["loading", "onClick"])
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
            class: "trip-discount"
          }, [
            _createVNode(_component_BaseInput, {
              name: "discount",
              label: "",
              placeholder: _ctx.$t('booking.tripDetails.discount.placeholder'),
              hasError: _ctx.v$.code.$error,
              errors: _ctx.v$.code.$errors,
              valid: !_ctx.v$.code.$invalid,
              modelValue: _ctx.v$.code.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.code.$model) = $event))
            }, null, 8, ["placeholder", "hasError", "errors", "valid", "modelValue"]),
            _createVNode(_component_BaseButton, {
              loading: _ctx.loading,
              class: "button--white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('booking.tripDetails.discount.button')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ], 32))
    ]),
    _: 1
  }, 8, ["error"]))
}